<template>
    <div>
        <slot v-if="$slots.default"/>
        <template v-else>
            <template v-if="attr">
                <template v-if="type && type === 'number'">
                    <el-input-number
                        ref="el"
                        @input="(val) => {handleFormItemChange(val)}"
                        :value="currentValue"
                        :size="attr.size"
                        :min="attr.min !== undefined ? attr.min : minInfinity"
                        :max="attr.max !== undefined ? attr.max : maxInfinity"
                        controls-position="right"
                        :placeholder="attr.placeholder">
                    </el-input-number>
                </template>
                <template v-else-if="type === 'radio'">
                    <el-radio-group ref="el" @input="(val) => {handleFormItemChange(val)}"
                        :value="currentValue">
                        <el-radio v-if="attr.options" v-for="(radio, index) in attr.options"
                            :key="index"
                            :label="radio.label">{{radio.text}}</el-radio>
                    </el-radio-group>
                </template>
                <template v-else-if="type && type === 'checkbox'"></template>
                <template v-else-if="type && type === 'switch'"></template>
                <template v-else-if="type && type.startsWith('date')"></template>
                <template v-else-if="type && type === 'image'">
                    <image-uploader
                        :options="attr.options"
                        :value="currentValue"
                        @input="handleFormItemChange"
                        :limit="attr.limit">
                    </image-uploader>
                </template>
                <template v-else-if="type && type === 'tree-selector'"></template>
                <template v-else-if="type && type === 'select'"></template>
                <template v-else-if="type && type === 'cascader'"></template>
                <template v-else-if="type && type === 'area'"></template>
                <template v-else>
                    <el-input
                        :type="type"
                        :value="currentValue"
                        @input="(val) => {handleFormItemChange(val)}"
                        :maxlength="attr.maxlength"
                        :minlength="attr.minlength"
                        :placeholder="attr.placeholder"
                        :rows="attr.rows"
                        :clearable="attr.clearable"
                        :style="attr.style ? attr.style : type === 'textarea' ? 'width:450px' : 'width:216px'"
                        :prefix-icon="attr.prefixIcon"
                        :suffix-icon="attr.suffixIcon"
                        :name="attr.name"
                        :resize="attr.resize !== undefined ? attr.resize : 'none'"
                        :autofocus="attr.autofocus">
                        </el-input>
                    <p v-if="type === 'textarea' && attr.maxlength !== undefined" class="text-nums" style="text-align: right;width: 450px;">{{currentValue && currentValue.length ? currentValue.length : 0}} / {{attr.maxlength}}</p>
                </template>
            </template>
            <template v-if="!attr && currentValue">{{currentValue}}</template>
         </template>
        <p v-if="prompt" :style="promptStyle ? promptStyle : promptDefaultStyle">{{prompt}}</p>
        <slot name="prompt"/>
    </div>
</template>

<script>
import ImageUploader from '@/components/image-uploader'
export default {
  name: 'form-widget',
  props: {
    type: '',
    attr: {
      required: true
    },
    value: {},
    prompt: ''
  },
  components: {
    ImageUploader
  },
  data () {
    return {
      currentValue: '',
      promptDefaultStyle: 'color: #999;font-szie: 12px;line-height: 20px;width: 588px;margin-top: 10px;'
    }
  },
  computed: {
    maxInfinity () {
      return Infinity
    },
    minInfinity () {
      return -Infinity
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler () {
        this.currentValue = this.value
      }
    }
  },
  methods: {
    handleFormItemChange (val) {
      this.currentValue = val
      this.$emit('input', val)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/profile/form-widget.vue